import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/products';

export default function FeaturedCategories() {
  const { t } = useTranslation();
  const featured = categories.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('featuredCategories')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            {t('featuredCategoriesDesc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.id}`}
              className="group relative overflow-hidden rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            {t('viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}